import type { PaymentSubState } from '@diamond/shared/types';

export const formatPaymentSubStateLabel = (value: PaymentSubState): string =>
  value === null ? 'null' : value;
